import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardBody, Button } from "reactstrap";
import Dropzone from "react-dropzone";
import { httpGet, httpUpload } from "../../common/petitions";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Models from './model.json';
import "./tables.scss";
import "./Puestos.scss";
import DataLoader from "../../components/tableData";
import { useNavigate } from 'react-router-dom';

const RubroServiciosInternos = () => {
  const [uploadResult, setUploadResult] = useState(null);
  const [dataMantenimiento, setDataMantenimiento] = useState({});
  const [dataTraslado, setDataTraslado] = useState({});
  const [dataPersonal, setDataPersonal] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const navigate = useNavigate();
  const nameTemplateExcel = 'PRESUPUESTOMAQ_SERVICIOSINTERNOS';

  const downloadTemplate = async () => {
    try {
      const response = await fetch(`/templates_xls/${nameTemplateExcel}.xlsx`);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${nameTemplateExcel}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error("Error downloading template:", error);
    }
  };

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const mantenimientoData = await httpGet(`/rubros/20242025/simantenimiento`, navigate);
      setDataMantenimiento({ "columns": Models.headers, "rows": mantenimientoData });

      const trasladoData = await httpGet(`/rubros/20242025/sitraslado`, navigate);
      setDataTraslado({ "columns": Models.headers, "rows": trasladoData });

      const personalData = await httpGet(`/rubros/20242025/sipersonal`, navigate);
      setDataPersonal({ "columns": Models.headers, "rows": personalData });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setIsLoading(false);
  };

  const uploadFile = async (file) => {
    setIsUploading(true);
    const formdata = new FormData();
    formdata.append("file", file);
    formdata.append("rubro", 'serviciosinternos');
    try {
      const result = await httpUpload(`/rubros/import`, formdata, navigate);
      setUploadResult(result);
      fetchData();
    } catch (error) {
      console.error("Error uploading file:", error);
    } finally {
      setIsUploading(false);
    }
  };

  const handleAcceptedFiles = (files) => {
    const file = files[0];
    uploadFile(file);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const options = {
    rowClassName: (row) => (row.rowIndex === 0 ? 'style="position: sticky; top: 0; background-color: #f2f2f2;"' : ''),
  };

  document.title = "Rubros - Ingreso serviciosinternos - IPG";
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs maintitle="Rubros" title="Ingreso serviciosinternos" />

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Dropzone onDrop={handleAcceptedFiles}>
                    {({ getRootProps, getInputProps }) => (
                      <div className="dropzone-container">
                        <div className="btn btn-success dropzone me-5" {...getRootProps()}>
                          <input {...getInputProps()} />
                          <span>Subir archivo</span>
                        </div>
                        {uploadResult && (
                          <div className="upload-check">
                            <i className="bx bx-check-circle"></i>
                          </div>
                        )}
                      </div>
                    )}
                  </Dropzone>

                  <Button color="light" className="mi-5" onClick={downloadTemplate}>
                    <i className="bx bx-download me-1"></i> Descargar Plantilla (.xlsx)
                  </Button>

                  <h1>SERVICIOS DE MANTENIMIENTO</h1>
                  <DataLoader isLoading={isLoading} data={dataMantenimiento} rubro={"simantenimiento"}reload={fetchData}/>

                  <h1>SERVICIOS DE TRASLADO</h1>
                  <DataLoader isLoading={isLoading} data={dataTraslado} rubro={"sitraslado"}reload={fetchData}/>

                  <h1>SERVICIOS DE PERSONAL</h1>
                  <DataLoader isLoading={isLoading} data={dataPersonal} rubro={"sipersonal"}reload={fetchData}/>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default RubroServiciosInternos;
